import styled from 'styled-components';
import { UpperText } from '@/components/ui/Title';

const Title = styled(UpperText)`
  letter-spacing: 2px;
  text-align: center;
`;

export default Title;
